import { PaletteMode } from "@mui/material/styles";

export const mindsetSegmentColors = [
  "#82E1F2",
  "#70c9f0",
  "#72b0e7",
  "#8294d5",
  "#9476b8",
  "#9e5892",
  "#9c3c65",
];

export const mindsetSegmentPalette = Object.fromEntries(
  mindsetSegmentColors.map((c, i) => [`segment${i}`, { main: c }])
) as Record<`segment${number}`, { main: string }>;


/*
  Bupa
 */

export const bupaTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#0079C8",
      light: "#80d5ff",
      dark: "#0657a6",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0079C8",
      light: "#80d5ff",
      dark: "#0657a6",
      contrastText: "#ffffff",
    },
    info: {
      main: "#0D1846",
      light: "#6a769f",
      dark: "#0D1846",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F2F1F1",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#F2F1F1",
    gradient: [
      "#cfe4ff",
      "#a8c8f1",
      "#80ade4",
      "#5493d6",
      "#0079c8"
    ],
    score: {
      main: "#F2F1F1",
      light: "#0079c8",
      dark: "#f3002c",
      contrastText: "#000000",
    },
    segments: mindsetSegmentColors,
    ...mindsetSegmentPalette,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 754,
      md: 1028,
      lg: 1200,
      xl: 1448,
    }
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#000000",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}

/*
  TfL
 */

export const tflTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#000F9F",
      light: "#441eb2",
      dark: "#1007A0",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#DA281B",
      light: "#ed7068",
      dark: "#bf0b01",
      contrastText: "#ffffff",
    },
    info: {
      main: "#333F49",
      light: "#8d9ca9",
      dark: "#222b32",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F2F1F1",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#F2F1F1",
    gradient: [
      "#eadcff",
      "#bea6e7",
      "#9072cf",
      "#5d41b7",
      "#000F9F"
    ],
    score: {
      main: "#F2F1F1",
      light: "#000F9F",
      dark: "#DA281B",
      contrastText: "#000000",
    },
    segments: mindsetSegmentColors,
    ...mindsetSegmentPalette,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 754,
      md: 1028,
      lg: 1200,
      xl: 1448,
    }
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#000000",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}


/*
  Rubicon
 */

export const rubiconTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#283385",
      light: "#9da6d2",
      dark: "#1b226f",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#EFB543",
      light: "#fbeea1",
      dark: "#e17a31",
      contrastText: "#1b226f",
    },
    info: {
      main: "#333F49",
      light: "#8d9ca9",
      dark: "#222b32",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F2F1F1",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#F2F1F1",
    gradient: [
      "#e4deff",
      "#b7afe0",
      "#8a83c1",
      "#5c59a3",
      "#283385"
    ],
    score: {
      main: "#F2F1F1",
      light: "#283385",
      dark: "#DA281B",
      contrastText: "#000000",
    },
    segments: mindsetSegmentColors,
    ...mindsetSegmentPalette,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 754,
      md: 1028,
      lg: 1200,
      xl: 1448,
    }
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#000000",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}

/*
  B&Q
 */

export const bnqTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#ff6600",
      light: "#ffc41f",
      dark: "#ff6600",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#323c41",
      light: "#859ba6",
      dark: "#323c41",
      contrastText: "#ffffff",
    },
    info: {
      main: "#333F49",
      light: "#8d9ca9",
      dark: "#222b32",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F2F1F1",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#F2F1F1",
    gradient: [
      "#b7eaff",
      "#93bbcc",
      "#718e9b",
      "#51636c",
      "#323c41"
    ],
    score: {
      main: "#F2F1F1",
      light: "#ff6600",
      dark: "#DA281B",
      contrastText: "#000000",
    },
    segments: mindsetSegmentColors,
    ...mindsetSegmentPalette,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 754,
      md: 1028,
      lg: 1200,
      xl: 1448,
    }
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#000000",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}


/*
  Screwfix
 */

export const screwfixTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: "#2e2cff",
      light: "#ae9afe",
      dark: "#001ceb",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ee1c26",
      light: "#f69595",
      dark: "#cf0019",
      contrastText: "#ffffff",
    },
    info: {
      main: "#333F49",
      light: "#8d9ca9",
      dark: "#222b32",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffb200",
      light: "#FFE081",
      dark: "#ff6e00",
      contrastText: "#212b3a",
    },
    error: {
      main: "#f3002c",
      light: "#fa8996",
      dark: "#c30013",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fff",
      paper: "#F2F1F1",
    },
    action: {
      active: "#212b3a",
    },
    divider: "#F2F1F1",
    gradient: [
      "#d7e1ff",
      "#abbbe7",
      "#7f97cf",
      "#5074b8",
      "#0053a0"
    ],
    score: {
      main: "#F2F1F1",
      light: "#2e2cff",
      dark: "#DA281B",
      contrastText: "#000000",
    },
    segments: mindsetSegmentColors,
    ...mindsetSegmentPalette,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 754,
      md: 1028,
      lg: 1200,
      xl: 1448,
    }
  },
  typography: {
    fontFamily: "cera-pro",
    allVariants: {
      color: "#000000",
    },
  },
  components: {
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
}
